import { useNavigate } from 'react-router'
import { useCallback } from 'react'
import { IBuffetDishWithImplInfoDto } from '../../../../../core/api/dto/BuffetDishDto'
import { AllRoutes } from '../../../../../core/routes/AllRoutes'

export const useNextStep = () => {
  const navigate = useNavigate()

  const onContinueHandler = useCallback(
    (dish: IBuffetDishWithImplInfoDto, orderIds?: string[]) => {
      if (orderIds && orderIds.length > 1 && !!dish) {
        navigate(
          `/${AllRoutes.planMenuIssuing.path}/${AllRoutes.choosePlanMenuIssuingDetail.path}/?ids=${orderIds}&dish=${dish.id}`,
        )
        return
      }
      if (!!orderIds && orderIds.length === 1 && !!dish) {
        navigate(`/${AllRoutes.planMenuIssuing.path}/${orderIds}/${dish.id}/`)
      }
    },
    [navigate],
  )

  return { onContinueHandler }
}
